export const FALLBACK_PUBLIC_PURCHASE_MOTIONS = {
  MERCH_CARD: {
    purchaseMotions: {
      'marketing-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-professional': [{
        key: 'TRIAL'
      }, {
        key: 'BUY_TOUCHLESS'
      }],
      'cms-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'tech-service-dedicated-ip-for-email': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'web-hosting-custom-ssl-pack': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'technical-consulting-ongoing': [{
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }, {
        key: 'TRIAL'
      }],
      'strategic-consulting-ongoing': [{
        key: 'TALK_TO_SALES'
      }],
      'service-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'service-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'training-agency-marketing-hub-fundamentals': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'domains-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'premium-consulting': [{
        key: 'TALK_TO_SALES'
      }],
      'api-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'transactional-email': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-enterprise': [{
        key: 'TRIAL'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-professional': [{
        key: 'TALK_TO_SALES'
      }, {
        key: 'TRIAL'
      }],
      'ads-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'brazil-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'strategic-consulting-monthly': [{
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }],
      'sales-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }],
      'service-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'brand-domain': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'hubspot-for-startups-setup': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'reporting-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'transcription-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }]
    }
  },
  CALCULATOR: {
    purchaseMotions: {
      'marketing-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-professional': [{
        key: 'BUY_TOUCHLESS'
      }],
      'tech-service-dedicated-ip-for-email': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'web-hosting-custom-ssl-pack': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'phone-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'technical-consulting-ongoing': [{
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'strategic-consulting-ongoing': [{
        key: 'TALK_TO_SALES'
      }],
      'service-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'calling-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'service-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'training-agency-marketing-hub-fundamentals': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'domains-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'premium-consulting': [{
        key: 'TALK_TO_SALES'
      }],
      'api-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'transactional-email': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-enterprise': [{
        key: 'TRIAL'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'ads-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'brazil-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-enterprise': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-enterprise-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'marketing-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'strategic-consulting-monthly': [{
        key: 'TALK_TO_SALES'
      }],
      'operations-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }],
      'sales-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-professional': [{
        key: 'TALK_TO_SALES'
      }],
      'sales-hub-starter-onboarding': [{
        key: 'TALK_TO_SALES'
      }],
      'cms-hub-starter': [{
        key: 'BUY_TOUCHLESS'
      }],
      'brand-domain': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'service-hub-professional-onboarding': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'hubspot-for-startups-setup': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'reporting-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      'transcription-limit-increase': [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }]
    }
  }
};